import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      '& .MuiCardContent-root:last-child': {
        paddingBottom: theme.spacing(3),
      },
    },
    cardContent: {
      padding: theme.spacing(3),
    },
    title: {
      paddingBottom: theme.spacing(5),
    },
  })
);
